export enum S3UploaderStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

interface UploadS3Props {
  gatewayEndPoint: string;
  uuid: string;
  files: File[];
  fileNameUrlMap: Map<string, string>;
  removeUpload: (uuid: string) => void;
  statusUpload?: (uuid: string, status: S3UploaderStatus, reason: string) => void;
  linkReference?: string;
  progressWidth?: number;
}

export default UploadS3Props;
